module.exports = __webpack_public_path__ + "02_glasses_red.461d9e56.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/dad/layer4/02_glasses_red.png
// module id = 15sE
// module chunks = 0